import type { ComponentSchema } from '../../../../../schema-types'
import { SECTION_STYLE_FIELDS } from './_fields'

/** A picture panel (or a grape panel without one) with a plum wash, the title, a line and one button. */
export const schema: ComponentSchema = {
  type: 'offer-banner',
  label: 'Offer banner',
  description: 'A picture panel with a title, text and one button.',
  supportedPages: ['home', 'shop', 'category'],
  variants: [{ id: 'v1', label: 'Picture panel' }],
  commonFields: [
    { key: 'image', label: 'Picture', type: 'image', help: 'Empty = a grape panel.' },
    { key: 'title', label: 'Title', type: 'string', default: 'Back to school: 15% off bags' },
    { key: 'subtitle', label: 'Text', type: 'text', default: 'Backpacks, lunch boxes and bottles for the new term.' },
    { key: 'ctaText', label: 'Button text', type: 'string', default: 'Shop now' },
    { key: 'ctaLink', label: 'Button link', type: 'string', default: '/shop' },
    { key: 'overlayOpacity', label: 'Dark wash (30–90)', type: 'number', default: 50 },
    ...SECTION_STYLE_FIELDS,
  ],
}
